var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ElementRef, EventEmitter, OnInit } from "@angular/core";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { obsolete } from "../../utilities/decorators/obsolete.decorator";
export class ButtonComponent {
    constructor(el) {
        this.el = el;
        this.text = "";
        this.icon = "";
        this.styleType = "fas";
        this.type = "fa";
        this.classes = "";
        this.styleClass = "";
        this.iconPos = "left";
        this.disabled = false;
        this.focusable = true;
        this.onClick = new EventEmitter();
    }
    get hasIcon() {
        return StringHelper.isAvailable(this.icon);
    }
    get iconClass() {
        return this.hasIcon ? `${this.styleType} ${this.type}-${this.icon}` : "";
    }
    ngOnInit() {
        if (!this.focusable) {
            this.el.nativeElement.firstElementChild.firstElementChild.tabIndex = -1;
        }
    }
}
__decorate([
    obsolete("Use 'classes' instead"),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "styleClass", void 0);
